import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';
import { setReasonRefusal } from '../../store/ducks/reasonRefusal/action';

export default function useUpdateReasonRefusal() {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  async function execute(
    reasonRefusalId: string,
    reason: string,
    description: string,
    callback?: () => void,
  ) {
    try {
      setLoading(true);
      const response = await api.put(
        `v1/backoffice/reasons-refusal/${reasonRefusalId} `,
        {
          reason,
          description,
        },
      );

      if (response.status === 200) {
        dispatch(
          setReasonRefusal({
            description: '',
            reason: '',
          }),
        );
        toast.success(ToastMessages.reasonRefusal.success.updateReasonRefusal);
        if (callback) {
          callback();
        }
      }
    } catch (error) {
      if (!Array.isArray((error as any).response.data.message)) {
        toast.success(ToastMessages.reasonRefusal.success.updateReasonRefusal);
      } else {
        (error as any).response.data.message.map((err: any) =>
          toast.error(ToastMessages.general.error.genericError),
        );
      }
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
